import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";

import {
    COURSE_CATEGORIES_ROUTE_TYPE,
    MACHINE_CATEGORIES_ROUTE_TYPE,
    PRODUCTS_CATEGORIES_ROUTE_TYPE,
    SERVICE_CATEGORIES_ROUTE_TYPE,
    BUSINESS_CATEGORIES_ROUTE_TYPE,
    SPECIAL_BUSINESS_CATEGORIES_ROUTE_TYPE,
} from "../components/editors/TreeEditorRouteTypes";


const COURSE_CATEGORIES_RESOURCE = 'course-categories';
const SERVICE_CATEGORIES_RESOURCE = 'service-categories';
const PRODUCT_CATEGORIES_RESOURCE = 'product-categories';
const MACHINE_CATEGORIES_RESOURCE = 'machine-categories';
const BUSINESS_CATEGORIES_RESOURCE = 'business-categories';
const SPECIAL_BUSINESS_CATEGORIES_RESOURCE = 'special-business-categories';

export function loadCategoriesSuccess(categories) {
    return {
        type: types.LOAD_CATEGORIES_SUCCESS,
        categories,
    };
}

export function loadCategoriesPending(contentType) {
    return {
        type: types.LOAD_CATEGORIES_PENDING,
        contentType,
    }
}

export function loadCategoriesFail(err, contentType) {
    return {
        type: types.LOAD_CATEGORIES_FAIL,
        contentType,
        err,
    };
}


export function updateCategorySuccess(categories) {
    return {
        type: types.UPDATE_CATEGORY_SUCCESS,
        categories,
    };
}

export function addCategorySuccess(categories) {
    return {
        type: types.ADD_CATEGORY_SUCCESS,
        categories
    }
}


export function categoryDeletedSuccess(categories) {
    return {
        type: types.DELETE_CATEGORY_SUCCESS,
        categories
    }
}

export function fetchCategories(contentType, portalId) {

    return function (dispatch) {
        return PrivateAPIResource.all(getResource(contentType), {portalId, tree: 1})
            .then(categories => {
                dispatch(loadCategoriesSuccess(categories))
            })
            .catch(err => {
                dispatch(loadCategoriesFail(err.message, contentType));
                console.error(err);
            });
    }
}


export function addCategory(contentType, params) {
    return function (dispatch) {
        return PrivateAPIResource.create(getResource(contentType), params)
            .then(categories => {
                dispatch(addCategorySuccess(categories))
            })
            .catch(err => {
                dispatch(loadCategoriesFail(err.message, contentType));
                console.error(err);
            });
    }
}

export function updateCategory(contentType, params) {
    return function (dispatch) {
        return PrivateAPIResource.put(`${getResource(contentType)}/${params.id}`, params)
            .then(categories => {
                dispatch(updateCategorySuccess(categories))
            })
            .catch(err => {
                dispatch(loadCategoriesFail(err.message, contentType));
                console.error(err);
            });
    }
}

export function deleteCategory(contentType, id) {
    return function (dispatch) {
        return PrivateAPIResource.remove(`${getResource(contentType)}`, id)
            .then((categories) => categoryDeletedSuccess(categories))
            .catch(err => {
                dispatch(loadCategoriesFail(err.message, contentType));
                console.error(err);
            });
    }
}


function getResource(contentType) {
    switch (contentType) {
        case COURSE_CATEGORIES_ROUTE_TYPE: return COURSE_CATEGORIES_RESOURCE;
        case MACHINE_CATEGORIES_ROUTE_TYPE: return MACHINE_CATEGORIES_RESOURCE;
        case SERVICE_CATEGORIES_ROUTE_TYPE: return SERVICE_CATEGORIES_RESOURCE;
        case PRODUCTS_CATEGORIES_ROUTE_TYPE: return PRODUCT_CATEGORIES_RESOURCE;
        case BUSINESS_CATEGORIES_ROUTE_TYPE: return BUSINESS_CATEGORIES_RESOURCE;
        case SPECIAL_BUSINESS_CATEGORIES_ROUTE_TYPE: return SPECIAL_BUSINESS_CATEGORIES_RESOURCE;
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/categoryTreeEditorActions.js